<template>
  <div>
    <base-modal :show="showModal" @close="handleClose" @save="saveEdit">
      <template v-slot:header> Discount </template>
      <template v-slot:main>
        <div>
          <el-select
            filterable
            v-model="discountSelected"
            placeholder="Select"
            class="w-full"
          >
            <el-option
              v-for="discount in discounts"
              :key="discount.id"
              :label="discount.name"
              :value="discount.name"
            >
            </el-option>
          </el-select>
        </div>
      </template>
    </base-modal>
  </div>
</template>

<script>
import BaseModal from "@/components/ui/elements/BaseModal";
const clone = require("lodash/cloneDeep");
export default {
  name: "AddDiscount",
  components: { BaseModal },
  props: ["showModal", "orderId", "discountName"],
  data() {
    return {
      discountSelected: null,
    };
  },
  methods: {
    handleClose() {
      this.$emit("close");
    },
    saveEdit() {
      this.$notify({
        title: "Discount",
        message: "Saving...",
        type: "success",
      });
      this.$store
        .dispatch("order/apply_discount", {
          orderId: this.orderId,
          code: this.discountSelected,
        })
        .then((resp) => {
          if (!resp.success) return;

          this.$notify({
            title: "Discount",
            message: "This discount has been applied",
            type: "success",
          });
          this.$emit("saved");
        });
    },
  },
  computed: {
    discounts: function () {
      return this.$store.getters["outfitter/getDiscounts"];
    },
  },
  mounted() {
    this.discountSelected = clone(this.discountName);
  },
};
</script>

<style scoped></style>
